<div class="grid-x">
  <div class="cell small-12">
    <label for="txtPayments">
      Context Location for Payments Due <span style="font-style: italic;">(Note: This should be correspond to the context location for a Payment Checkout component in this flow.)</span>
    </label>
    <input type="text" [(ngModel)]="componentData.config.payments" />
  </div>
  <div class="cell small-12">
    <label for="txtAddress">
      Payment Address to Use:
    </label>
    <textarea id="txtAddress" [(ngModel)]="componentData.config.paymentAddress"></textarea>
  </div>
  <div class="cell small-12">
    Type of <span class="bold">invoice</span> to use:
  </div>
  <div class="cell small-12">
    <text-loader [run]="invoiceTypes == null" [text]="'Loading Invoice Types'" [tickType]="'.'" [interval]="1500"></text-loader>
    @if (invoiceTypes != null) {
      <select [ngModel]="selectedInvoiceType" (ngModelChange)="invoiceTypeChanged($event)">
        @for (type of invoiceTypes; track type) {
          <option [ngValue]="type.name">{{type.name}}</option>
        }
      </select>
    }

  </div>
  <div class="cell small-12">
    Type of <span class="bold">receipt</span> to use:
  </div>
  <div class="cell small-12">
    <text-loader [run]="receiptTypes == null" [text]="'Loading Receipt Types'" [tickType]="'.'" [interval]="1500"></text-loader>
    @if (receiptTypes != null) {
      <select [ngModel]="selectedReceiptType" (ngModelChange)="receiptTypeChanged($event)">
        @for (type of receiptTypes; track type) {
          <option [ngValue]="type.name">{{type.name}}</option>
        }
      </select>
    }
  </div>
</div>